// tienda/TecnologiaSection.jsx
// 6-feature technology grid.

import React from "react";
import { motion } from "framer-motion";
import { MapPin, MessageSquare, HandCoins, BarChart3, FileSpreadsheet, ShieldCheck } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const FEATURES = [
  { icon: <MapPin className="size-5"/>,          title: "Ubicación en vivo",   text: "Comparte la ubicación del driver con tu cliente en tiempo real." },
  { icon: <MessageSquare className="size-5"/>,   title: "WhatsApp API",         text: "Chat centralizado y notificaciones automáticas en cada hito." },
  { icon: <HandCoins className="size-5"/>,       title: "Cobro contraentrega",  text: "Cobramos por ti y te depositamos. Flujo de caja predecible." },
  { icon: <BarChart3 className="size-5"/>,       title: "Dashboard completo",   text: "KPIs, OTD, rechazos, conciliación y depósitos del día." },
  { icon: <FileSpreadsheet className="size-5"/>, title: "Carga masiva Excel",   text: "Sube todos tus pedidos con un solo archivo." },
  { icon: <ShieldCheck className="size-5"/>,     title: "Marketplace incluido", text: "Tus productos visibles en la tienda Fast Max sin costo extra." },
];

export function TecnologiaSection() {
  return (
    <section id="tecnologia" className="border-b border-slate-100 bg-slate-50 scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <motion.h2 {...fadeUp} className="text-2xl font-extrabold mb-8" style={{ color: brand.primary }}>
          Todo lo que necesitas en un solo lugar
        </motion.h2>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {FEATURES.map(f => (
            <motion.div key={f.title} {...fadeUp} className="rounded-2xl border border-slate-100 bg-white p-4">
              <div
                className="size-9 rounded-xl flex items-center justify-center mb-3"
                style={{ background: brand.primary + "15", color: brand.primary }}
              >
                {f.icon}
              </div>
              <h3 className="text-sm font-bold text-slate-800 mb-1">{f.title}</h3>
              <p className="text-xs text-slate-500 leading-relaxed">{f.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}